import React, { useEffect, useState } from "react"
import { MenuRouter } from "@router/index";
import { getPathStage, isDef, parseSearch, treeDataToFlatArr } from "@utils/index";
import { Breadcrumb, Button, Tabs, Tooltip } from "antd"
import { useHistory, useLocation } from "react-router-dom"
import { Icon } from "..";
import { useCacheDispatch, } from 'react-keepalive-router'
import { useDispatch, useSelector } from "react-redux";
import { StateType } from "@store/index";
import { setHistoryList } from "@store/actions";
// import { asyncSetHistoryList } from "@store/actions";
const { TabPane } = Tabs

const Breadcrumbs = () => {
    const { pathname, search } = useLocation();
    const { fromPath } = parseSearch(search)
    const pathStage = [...getPathStage(pathname), fromPath || pathname]
    const flatArr = treeDataToFlatArr(MenuRouter, false)
    const breadcrumbArr = pathStage.map(v => {
        return flatArr.find(r => v === r.path) || {}
    })
    return (<Breadcrumb style={{background: '#fff', boxSizing: 'border-box', padding: 16, borderTop: '1px solid #F1F3F6'}}>
        <Breadcrumb.Item key="home"><Icon type="icon-shouye1" /><a href='/home'>首页</a></Breadcrumb.Item>
        {
            (breadcrumbArr||[]).map(v => <Breadcrumb.Item key={v.path}><a href={v.path}>{v.name}</a></Breadcrumb.Item>)
        }
      </Breadcrumb>)
}

export default () => {
    const { historyList: routeList } = useSelector((state: StateType) => state)
    const cacheDispatch = useCacheDispatch()
    const dispatch = useDispatch();
    const { pathname, search } = useLocation();
    const history = useHistory()
    const {name: sName, customerName, fromPath, routeName, routeTitName } = parseSearch(search) || {}
    const fullPath = `${pathname}${search}`
    const title = routeTitName || sName || customerName

    const flatArr = treeDataToFlatArr(MenuRouter, false)
    const onEdit = (targetKey: any, action: string) => {
       if (action === 'remove') {
           if (routeList?.length > 1) {
                const { cacheId } = routeList.find(({fullPath}) => fullPath === targetKey)
                const newRouteList = routeList.filter(({fullPath}) => fullPath !== targetKey)
                fullPath === targetKey && history.push(newRouteList[newRouteList.length -1].fullPath)
                dispatch(setHistoryList(newRouteList))
                // 叉掉的时候消除页面缓存
                cacheDispatch({ type:'reset',payload: cacheId })
           }
       }
    }

    const uniqueRouteList = (pathname: string, unique: boolean = true) => {
        const { name, path, cacheId: calcCacheId } = flatArr.find(v => v.path === pathname) || {}
        const cacheId = (!isDef(calcCacheId) || typeof calcCacheId === 'string') ? (calcCacheId || path) : calcCacheId()
        const tabContent = routeName || name
        if (unique) {
            const unqiueTabContent = [...new Set(routeList.map(({tabContent}) => tabContent))]
            const idx = unqiueTabContent.indexOf(tabContent) 
            const newRouteList = idx < 0 ? [...routeList, {tabContent, title, fullPath, cacheId }] : (routeList[idx] = {tabContent, title, fullPath, cacheId }, routeList)
            dispatch(setHistoryList([...newRouteList]))
        } else {
            const unqiueFullPath = [...new Set(routeList.map(({fullPath}) => fullPath))]
            if (!unqiueFullPath.includes(fullPath)) {
                dispatch(setHistoryList([...routeList, {tabContent, title, fullPath, cacheId}]))
            }
        }
    }
    
    useEffect(() => {
        if (!['/'].includes(pathname)) {
            uniqueRouteList(pathname)
        }
    }, [pathname])

    const Tab = (v: any) => {
        return <Tooltip placement="top" title={v.title}>{v.tabContent}</Tooltip>
    }

    return (<Tabs activeKey={fullPath} onChange={history.push} onEdit={onEdit} type="editable-card" hideAdd tabBarStyle={{margin: 0, marginTop: 5}}>
      {
        routeList.map(v => <TabPane key={v.fullPath} tab={Tab(v)} />)
      }
    </Tabs>)
}
